module.exports = __webpack_public_path__ + "static/media/highland-lakes.3232badc.pdf";